// Shared between GameScoreboardSection (the table's info banner) and
// ScoreboardDetailModal (the same info, scoped to whichever row was clicked) so the
// wording/format can't drift between the two places it's shown.
const fmtRangeDate = (val) => {
  if (!val) return '';
  const d = new Date(val);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

// What the currently-applied filter actually resolved to, in plain words — the backend
// is the source of truth for the exact from/to, this just phrases it per filter type so
// "Monthly" reads as "this month", not a bare date pair.
export const describeScoreboardRange = (filterType, from, to) => {
  if (filterType === 'alltime') return 'Showing all-time scores — every match ever recorded.';
  if (!from || !to) return null;
  const range = `${fmtRangeDate(from)} – ${fmtRangeDate(to)}`;
  if (filterType === 'weekly') return `Showing scores for this week: ${range}`;
  if (filterType === 'monthly') return `Showing scores for this month: ${range}`;
  return `Showing scores for: ${range}`;
};
